export const module = {
  info: {
    name: 'voip-dialplan',
    caption: 'voip dialplan',
    viewGroup: 'general-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    caption: 'Dialplan',
    icon: 'el-icon-phone',
    routeName: 'module->voip-dialplan->create',
    children: [
      {
        caption: 'Create Dialplan',
        icon: 'el-icon-plus',
        routeName: 'module->voip-dialplan->create'
      },
      {
        caption: 'List Dialplans',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-dialplan->list->page',
        routeParams: { listPage: 1}
      }
    ]
  }
}

export default module
